import React from 'react';

const StripeWithText = () => (
  <svg
    width="70"
    height="20"
    viewBox="0 0 70 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.2002 10.288C69.2002 7.21599 67.7122 4.79199 64.8682 4.79199C62.0122 4.79199 60.2842 7.21599 60.2842 10.264C60.2842 13.876 62.3242 15.7 65.2522 15.7C66.6802 15.7 67.7602 15.376 68.5762 14.92V12.52C67.7602 12.928 66.8242 13.18 65.6362 13.18C64.4722 13.18 63.4402 12.772 63.3082 11.356H69.1762C69.1762 11.2 69.2002 10.576 69.2002 10.288ZM63.2722 9.14799C63.2722 7.79199 64.1002 7.22799 64.8562 7.22799C65.5882 7.22799 66.3682 7.79199 66.3682 9.14799H63.2722Z"
      fill="#6856D9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.6519 4.79199C54.4759 4.79199 53.7199 5.34399 53.2999 5.72799L53.1439 4.98399H50.5039V18.976L53.5039 18.34L53.5159 14.944C53.9479 15.256 54.5839 15.7 55.6399 15.7C57.7879 15.7 59.7439 13.972 59.7439 10.168C59.7319 6.68799 57.7519 4.79199 55.6519 4.79199ZM54.9319 13.06C54.2239 13.06 53.8039 12.808 53.5159 12.496L53.5039 8.04399C53.8159 7.69599 54.2479 7.45599 54.9319 7.45599C56.0239 7.45599 56.7799 8.67999 56.7799 10.252C56.7799 11.86 56.0359 13.06 54.9319 13.06Z"
      fill="#6856D9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.376 4.084L49.388 3.436V1L46.376 1.636V4.084Z"
      fill="#6856D9"
    />
    <rect x="46.376" y="4.99597" width="3.012" height="10.5" fill="#6856D9" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.1478 5.88399L42.9558 4.99599H40.3638V15.496H43.3638V8.37999C44.0718 7.45599 45.2718 7.62399 45.6438 7.75599V4.99599C45.2598 4.85199 43.8558 4.58799 43.1478 5.88399Z"
      fill="#6856D9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.148 2.39197L34.22 3.01597L34.208 12.628C34.208 14.404 35.54 15.712 37.316 15.712C38.3 15.712 39.02 15.532 39.416 15.316V12.88C39.032 13.036 37.136 13.588 37.136 11.812V7.55197H39.416V4.99597H37.136L37.148 2.39197Z"
      fill="#6856D9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.036 8.04399C29.036 7.57599 29.42 7.39599 30.056 7.39599C30.968 7.39599 32.12 7.67199 33.032 8.16399V5.34399C32.036 4.94799 31.052 4.79199 30.056 4.79199C27.62 4.79199 26 6.06399 26 8.18799C26 11.5 30.56 10.972 30.56 12.4C30.56 12.952 30.08 13.132 29.408 13.132C28.412 13.132 27.14 12.724 26.132 12.172V15.028C27.248 15.508 28.376 15.712 29.408 15.712C31.904 15.712 33.62 14.476 33.62 12.328C33.608 8.75199 29.036 9.38799 29.036 8.04399Z"
      fill="#6856D9"
    />
    <circle cx="10" cy="10" r="10" fill="#F3F5FE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.53117 7.68022C9.53117 7.29451 9.85132 7.14615 10.3816 7.14615C11.1419 7.14615 12.1024 7.37363 12.8627 7.77912V5.45495C12.0323 5.12857 11.212 5 10.3816 5C8.35063 5 7 6.04835 7 7.7989C7 10.5286 10.8018 10.0934 10.8018 11.2703C10.8018 11.7253 10.4016 11.8736 9.84132 11.8736C9.01093 11.8736 7.95044 11.5374 7.11005 11.0824V13.4363C8.04048 13.8319 8.98092 14 9.84132 14C11.9223 14 13.3529 12.9813 13.3529 11.211C13.3429 8.26374 9.53117 8.78791 9.53117 7.68022Z"
      fill="#6856D9"
    />
  </svg>
);

export default StripeWithText;
